require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./testing-react-ui-testing.json") })
        }
      }, "path---testing-react-ui-testing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---testing-react-ui-testing!./.cache/json/testing-react-ui-testing.json
// module id = 431
// module chunks = 231608221292675